import { __assign } from 'tslib';
import * as React from 'react';

/**
 * @description Rotate icon component.
 *
 * @component
 * @example
 * ```jsx
 * import { Rotate } from '@sravni/design-system-icons'
 *
 * <Rotate />
 * ```
 */
var Rotate = React.forwardRef(function (props, ref) { return (React.createElement("svg", __assign({ ref: ref, "data-qa": "Rotate", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props),
    React.createElement("path", { d: "m10.908 4.583 1.25-1.25-1.25-1.25M9.092 15.417l-1.25 1.25 1.25 1.25", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
    React.createElement("path", { d: "M14.728 5.31A6.637 6.637 0 0 1 16.667 10a6.667 6.667 0 0 1-8.551 6.392M5.212 14.635A6.643 6.643 0 0 1 3.333 10a6.667 6.667 0 0 1 8.551-6.393", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }))); });

export { Rotate };
//# sourceMappingURL=Rotate.js.map
